import { createSlice } from '@reduxjs/toolkit';
import { login } from './actions';

const initialState = {
  isLoggingIn: false,
  isLoggedIn: false,
  data: {},
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: {
    [login.pending]: (state) => {
      state.isLoggingIn = true;
    },
    [login.fulfilled]: (state, { payload }) => {
      state.isLoggingIn = false;
      state.isLoggedIn = true;
      state.data = payload?.data;
    },
  },
});
export default authSlice.reducer;
